<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <button tabindex="0" type="submit" class="search__submit">
        <svg class="bi" width="20" height="20" fill="currentColor">
          <use href="../../static/bi-sprite.svg?#search2" />
        </svg>
      </button>
    </div>
    <label for="search" class="sr-only">Søg produkter, artikler, brands</label>
    <input
      type="search"
      name="q"
      class="form-control form-control-lg"
      id="search"
      placeholder="Søg produkter, artikler, brands"
      v-model="value"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { debounce } from "../../js/utils/debounce.js";

export default Vue.extend({
  name: "SearchField",
  components: {},
  props: [
    "delay"
  ],
  data() {
    return {
      value: new URLSearchParams(window.location.search).get("q") ?? ""
    };
  },
  created() {
    this.debouncedSearch = debounce((newValue) => {      
      this.$emit("input", newValue);
    }, this.delay);
  },
  methods: {},
  computed: {},
  watch: {
    value(...args) {
      this.debouncedSearch(...args);
    }
  }
});
</script>
